import styled from 'styled-components'
import { v1 as color, media } from 'sidecar-design-library'

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const ListItem = styled.li`
  display: flex;

  &:not(:last-child) {
    margin-bottom: 0.625rem;
  }
`

export const Label = styled.label`
  color: #0e60c9;
  font-size: 1.125rem;
  line-height: 1.5625rem;
  margin-left: 0.625rem;

  &:hover {
    color: #0b4fa5;
    cursor: pointer;
  }

  ${media.belowTablet`
    white-space: normal;
  `}
`
